import { getAllSpecializationAreasReq } from "../../../../../redux/guest-slices/common.slice"
import SpecializationAreas from "../../../../../components/ui/SpecializationAreas"
import InputField1 from "../../../../../components/ui/InputField1"
import FileInput from "../../../../../components/ui/FileInput"
import { Grid2 as Grid, Typography } from "@mui/material"
import { useDispatch, useSelector } from "react-redux"
import { Fragment, useEffect, useState } from "react"
import { validateNumber } from "../../../../../utils/velidations"

function MeditationTeacher({ errors, files, onChangFun }) {
  const dispatch = useDispatch()
  const [areas, setAreas] = useState([])
  const { specialist } = useSelector(state => state.specialistSlice)

  const handleGetAreas = (filters) => {
    dispatch(getAllSpecializationAreasReq({
      limit: filters?.limit || 10,
      id: "67d90056c2c4d5ab747f8b36"
    })
    ).unwrap().then((data) => {
      setAreas(data)
    }).catch(() => { })
  }

  useEffect(() => {
    handleGetAreas()

    // eslint-disable-next-line
  }, [])

  return (
    <Fragment>
      <Grid size={12}>
        <InputField1
          type="text"
          errors={errors}
          name="trainingBackground"
          label="Meditation Training Background *"
          placeholder="Enter Meditation Training Background"
          errText="Please enter meditation training background"
          defaultValue={specialist?.profile?.trainingBackground || ""}
        />
      </Grid>

      <Grid size={12}>
        <SpecializationAreas
          areas={areas}
          errors={errors}
          onChangFun={onChangFun}
          label="Types of Meditation Taught *"
          errText="Please select types of meditation taught"
        />
      </Grid>


      <Grid size={12}>
        <InputField1
          type="text"
          errors={errors}
          name="experience"
          onChangeFun={validateNumber}
          label="Teaching Experience *"
          placeholder="Enter Teaching Experience"
          errText="Please enter teaching experience"
          defaultValue={specialist?.profile?.experience || ""}
        />
      </Grid>

      <Grid size={12} sx={{ "> div + div:has(div)": { mt: 2 } }}>
        <FileInput
          files={files}
          errors={errors}
          name="additionalCertificates"
          label="Ceritification Documents"
          placeholderText="Upload Additional Certificates"
          defaultValue={specialist?.profile?.additionalCertificates || []}
        />
      </Grid>

      <Typography
        color="#7A8A9E"
        fontWeight="500"
        fontStyle="italic"
      >Register as a Yoga Teacher on Innerpal. Your practice in teaching yoga enriches lives. Share your qualifications and teaching style to connect with our wellness community
      </Typography>
    </Fragment>
  )
}

export default MeditationTeacher